<template>
  <div class="box-detalhe" v-if="config.open">
    <el-row style="padding: 0 0 15px 0">
      <el-col :span="24">
        <Mapa ref="mapRef" v-if="config.open" :locations="locations" :config="config"
              :onMarkerClick="processMarkerClick" :pin-color="esquemaDeCor.aplicacao.corPrimariaAplicacao">
          <div v-if="credenciadoSelecionado" class="map-selector">
            <div class="arrow-icon" @click="move(false)">
              <i class="el-icon-arrow-left" />
            </div>
            <el-card class="credenciado-card" @click.native="detalhe()">
              <div class="header">
                {{ credenciadoSelecionado.nome }}
              </div>
              <Func4Acreditacao :acreditacoes="credenciadoSelecionado.acreditacoes" />
              <div class="info">
                <div>
                  {{ credenciadoSelecionado.esp }}
                </div>
                <div style="display: flex; justify-content: space-between;">
                <span>
                    {{ credenciadoSelecionado.bairro }}, {{ credenciadoSelecionado.cid }}
                </span>
                  <!-- <span>5,4 km</span>-->
                </div>
                <div>
                <span>
                  {{ credenciadoSelecionado.tel }}
                </span>
                  <span v-if="credenciadoSelecionado.tel_sec">
                  - {{ credenciadoSelecionado.tel_sec }}
                </span>
                </div>

              </div>
            </el-card>
            <div class="arrow-icon" @click="move(true)">
              <i class="el-icon-arrow-right" />
            </div>
          </div>
        </Mapa>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import Mapa from '@/components/mapa/Mapa'
import Func4Acreditacao from '@/views/4/Acreditacao'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Func4ListagemMapa',
  computed: {
    ...mapState('SetupApp', ['esquemaDeCor'])
  },
  components: {
    Func4Acreditacao,
    Mapa
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    redeCredenciada: {
      type: Array,
      required: true
    },
    locations: {
      type: Array,
      required: true
    }
  },
  methods: {
    ...mapActions('RedeCredenciada', ['setViewDetalhe', 'setPrestador']),
    detalhe () {
      if (this.credenciadoSelecionado == null) return

      this.setPrestador(this.credenciadoSelecionado)
      this.setViewDetalhe(true)
      this.$router.push({ path: `/4`, query: { detalhe: this.credenciadoSelecionado.id } })
    },
    initLocations () {
      if (!this.redeCredenciada || !this.redeCredenciada.length) return

      this.credenciados = []

      for (const credenciado of this.redeCredenciada) {
        if (!credenciado || !credenciado.credenciados) continue

        const credenciadosComLocalizacao = credenciado.credenciados.filter(x => x != null && x.lat && x.lon)

        if (!credenciadosComLocalizacao) continue

        this.credenciados.push(...credenciadosComLocalizacao)
      }

      if (this.credenciados && this.credenciados.length) {
        setTimeout(() => this.selectCredenciado(this.credenciados[0]), 700)
      }
    },
    move (next = true) {
      const currentIndex = this.credenciados.indexOf(this.credenciadoSelecionado)
      let nextIndex = next ? currentIndex + 1 : currentIndex - 1
      if (nextIndex < 0) nextIndex = this.credenciados.length - 1
      if (nextIndex === this.credenciados.length) nextIndex = 0

      this.selectCredenciado(this.credenciados[nextIndex])
    },
    processMarkerClick (googleMarker) {
      const credenciado = googleMarker.refObject
      if (credenciado) this.selectCredenciado(credenciado)
    },
    selectCredenciado (credenciado) {
      this.credenciadoSelecionado = credenciado
      const lat = credenciado.lat
      const lon = credenciado.lon

      if (!this.$refs.mapRef) return

      this.$refs.mapRef.panToPosition(lat, lon)
    }
  },
  data () {
    return {
      credenciados: {},
      credenciadoSelecionado: false
    }
  },
  mounted () {
    this.initLocations()
  }
}

</script>

<style scoped lang="less">
.arrow-icon {
  display: flex;
  align-items: center;
  place-content: center;
  box-shadow: 0 0 2px 0 lightgray;
  font-weight: bold;
  cursor: pointer;
  font-size: xx-large;
  background-color: white;
  border-radius: 5px;
  color: var(--cor-primaria-aplicacao);
  width: 50px;
  margin-bottom: 15px;
}

.map-selector {
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 10px;
}

.credenciado-card {
  cursor: pointer;
  width: 400px;
  border-radius: 5px;
  font-size: 12px;

  .header {
    font-size: 16px;
    font-weight: 600;
  }

  .info {
    font-size: 12px;
  }
}
</style>
